/**
 * Route for `in-app-fraud-rules`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { InAppFraudRulesPage } from "../features/in-app-fraud-rules/InAppFraudRulesPage";

export const inAppFraudRulesRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/in-app-fraud-rules",
	component: InAppFraudRulesPage,
});

export default inAppFraudRulesRoute;
